// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import RotateCloseTo from "../../../../engines/components/tweens/RotateCloseTo";
import O1HD from "../../../../engines/gameEngine";
import { GeneralKind } from "../../../define/GeneralKind";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { TaskKind } from "../../../define/TaskKind";
import NormalGameManager from "../../manager/NormalGameManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class OpenOreCollectLayer extends BasePopUpLayer {

	@property({ type: cc.Node, displayName:'' })
	nodeLight: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnComClose: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeRet: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeCom: cc.Node = null;

    @property(cc.Node)
    nodePropList: cc.Node = null;


    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initLayer();
    }

    initLayer() {
        this.nodeRet.active = false;   
        this.nodeCom.active = true;   
        this.nodeLight.active = false;

        O1HD.getModules().uiControlModule.hideLoading();
    }

    onClickCom(event: cc.Event.EventTouch) {
        this.btnComClose.active = false;
        event.getCurrentTarget().getComponent(cc.Button).interactable = false;
        this.nodePropList.children.forEach((v)=> {
            v.getComponent(RotateCloseTo).setStartRotate(true);
        });
        this.scheduleOnce(this.startAni, 0.8);
    }

    startAni() {
        this.nodeLight.active = true;
        this.nodeLight.opacity = 150;

        let t3 = 0.2;
        cc.tween(this.nodeLight)
        .to(0.2, {opacity: 250})
        .parallel(
            cc.tween().to(0.25, {scale: 3})
            , cc.tween().to(0.25, {opacity: 255})
        )
        .call(()=> {
            cc.tween(this.nodeCom)
            .to(t3, {opacity: 0})
            .start();

            this.nodeRet.opacity = 0;
            this.nodeRet.active = true;
            cc.tween(this.nodeRet)
            .to(t3, {opacity: 255})
            .start();
        })
        .to(0.2, {opacity: 0})
        .call(this.finishComDispose.bind(this))
        .start();
    }

    finishComDispose() {
        let gameData = NormalGameManager._instance.getGameData();
        gameData.nvWaStore = [];
        NormalGameManager._instance.writeGameData();

        NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_4);

        NormalGameManager._instance.onPushGoods(GeneralKind.PropId.SHEN_NONG_DING, 1);

        O1HD.emit(MessageEventKind.EventName.REFRESH_NVWA_STORE_COLLECT);
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }

    // update (dt) {}
}
